export default function MarketTicker({ market }) {
  if (!market) return null;
  const items = [
    { label: 'NIFTY 50', ...market.nifty },
    { label: 'SENSEX', ...market.sensex },
    { label: 'USD / INR', ...market.usdinr },
  ].filter((i) => i.value);

  return (
    <div className="ticker" role="list" aria-label="Market snapshot">
      {items.map((i) => (
        <div className="ticker__item" role="listitem" key={i.label}>
          <div className="ticker__label">{i.label}</div>
          <div className="ticker__value">{i.value}</div>
          <div className={`ticker__chg ${i.dir === 'down' ? 'down' : 'up'}`}>
            {i.dir === 'down' ? '▼' : '▲'} {i.change}
          </div>
        </div>
      ))}
    </div>
  );
}
